import { Box, Skeleton, styled } from '@mui/material';
import { SectionHeader } from '../AssetsPage/SectionHeader';
import { BodyText } from '../BodyText';
import { RefreshContents } from '../ContentsTable/RefreshContents';

const SideBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
});

const Legend = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
});

const LegendItem = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '2px 4px',
  borderRadius: '4px',
});

interface AssetStateChartSkeletonProperties {
  onRefresh?: () => void;
}

export const AssetStateChartSkeleton = ({ onRefresh }: AssetStateChartSkeletonProperties) => {
  const header = (
    <SectionHeader>
      <BodyText color='text.secondary'>Status</BodyText>
      <RefreshContents onRefresh={onRefresh} />
    </SectionHeader>
  );

  return (
    <SideBox>
      <Box>{header}</Box>
      <Box marginTop='6px'>
        <Legend>
          {[1, 2].map(index => (
            <LegendItem key={index} marginLeft='6px'>
              <Skeleton variant='rectangular' width={16} height={16} sx={{ borderRadius: '3px' }} />
              <Skeleton variant='text' width={120} height={20} />
            </LegendItem>
          ))}
        </Legend>
        <Box display='flex' justifyContent='center' marginTop='16px'>
          <Skeleton variant='circular' width={160} height={160} />
        </Box>
        <Box>
          <Skeleton variant='text' width={150} height={20} sx={{ margin: '6px auto 0' }} />
        </Box>
      </Box>
    </SideBox>
  );
};
